// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__fqHt8","title":"style__title__McY8Z","description":"style__description__l4k5X","component":"style__component__5JhhV"};